import { FC, useMemo } from 'react'
import { useAtomValue } from 'jotai'
import styled from '@emotion/styled'
import { PARCEL_TYPES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { formatVal } from 'src/utils/number-format'
import { DonutChart } from 'src/v2/components/donut-chart'
import { Table } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/table'
import { Title } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/title'
import * as atoms from 'src/v2/state/owner-reveal/portfolio-summary'

const CHART_SIZE = 280

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Content = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

const ChartWrapper = styled.div`
  display: flex;
  width: ${CHART_SIZE}px;
`
export const AssessedValues: FC = () => {
  const value = useAtomValue(atoms.propertyTypesAssesedValue)
  const totalValue = useAtomValue(atoms.totalAssessedValue)

  const chartData = useMemo(() => {
    if (!value) {
      return []
    }
    return value.map((item) => ({
      y: item.value,
      color: PARCEL_TYPES_MAP.get(item.propertyType)?.color ?? 'gray',
      name: PARCEL_TYPES_MAP.get(item.propertyType)?.label ?? 'Unknown',
    }))
  }, [value])

  const tableData = useMemo(() => {
    if (!value) {
      return []
    }
    return value.map((item) => ({
      type: item.propertyType,
      value: formatVal(item.value, 'currency-long'),
      percentage: item.percentage,
    }))
  }, [value])

  return (
    <Container>
      <Title>Assessed Values</Title>
      <Content>
        <ChartWrapper>
          <DonutChart
            height={CHART_SIZE}
            data={chartData}
            title={formatVal(totalValue, 'currency')}
            subtitle="Assessed Value"
          />
        </ChartWrapper>
        <Table data={tableData} valueHeader="Assessed Value" />
      </Content>
    </Container>
  )
}
